import { appendOrdinal } from '@maxpreps/shared/functions/primitiveHelpers/numberHelpers';
import { getFormattedRecordFromStandings } from '@maxpreps/shared/functions/utils/teamUtils';
import { IRecordCardProps } from '../../components/shared/RecordCard/RecordCard';

const getRecordCardProps = (standings, leagueStandings): IRecordCardProps => {
  const overallRecord = getFormattedRecordFromStandings(standings, 'overall');
  const leagueRecord = getFormattedRecordFromStandings(standings, 'conference');
  const homeRecord = getFormattedRecordFromStandings(standings, 'home');
  const awayRecord = getFormattedRecordFromStandings(standings, 'away');
  const neutralRecord = getFormattedRecordFromStandings(standings, 'neutral');
  const pf = standings?.points?.toLocaleString() || 0;
  const pa = standings?.pointsAgainst?.toLocaleString() || 0;
  const streak = standings?.streak;
  const streakResult = standings?.streakResult;
  const overallWinPercentage = standings?.winningPercentage;
  const leagueWinPercentage = standings?.conferenceWinningPercentage;
  const leagueStandingPlacement =
    appendOrdinal(leagueStandings?.conferenceStandingPlacement) || undefined;

  return {
    overallRecord,
    overallWinPercentage,
    leagueRecord,
    leagueStandingPlacement,
    leagueWinPercentage,
    homeRecord,
    awayRecord,
    neutralRecord,
    pf,
    pa,
    streak,
    streakResult
  };
};

export default getRecordCardProps;
